//@ts-nocheck
import styled, { css } from 'styled-components'
import { primaryFont } from '../../../theme/fonts'
import { getFontClassName } from '../../../theme/fonts'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import palette from '../../../theme/palette'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.styles'

interface TAccordionList {
  colorScheme: ColorSchemeTypes
}

/**
 * Utils
 */
const preventChildrenFromBeingTabbed = css`
  visibility: hidden;
  opacity: 0;
  transition: all ${({ theme }) => theme.timing.fast} ease-in 0s;

  // Prevent children from being tabbed
  ${({ $open }) => $open && css`
    visibility: visible;
    opacity: 1;
  `}
`


/**
 * BASE
 */
export const BaseAccordion = styled.div`
  height: ${({ theme }) => theme.rem(63)};
  overflow: hidden;
  // margin-bottom: ${({ theme }) => theme.rem(16)};

  ${({ disabled }) => disabled && css`
    pointer-events: none;
  `}
`

export const BaseHeader = styled.button`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  text-align: left;
  padding: ${({ theme }) => theme.rem(16, 16, 16, 0)};
  transition: background-color 0.3s ease-in-out, padding-left 0.3s ease-in-out;
  cursor: pointer;
  font-family: ${process.env.STORYBOOK ? 'Everett' : 'inherit'};
  ${getFontClassName(primaryFont)}


`

export const BaseHeaderContent = styled.div`
  width: 100%;
  padding-right: ${({ theme }) => theme.rem(32)};
`

export const BaseContent = styled.div`
  ${preventChildrenFromBeingTabbed};

  padding: ${({ theme }) => theme.rem(16, 0)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding: ${theme.rem(32, 60, 32, 0)};
  `)}
`

export const BaseIconLeft = styled.div`
  margin-right: ${({ theme }) => theme.rem(16)};

  i {
    font-size: ${({ theme }) => theme.rem(48)};
  }

  ${({ theme }) => theme.mediaQuery.lg(`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${theme.rem(8)};
  `)}
`

export const BaseIconRight = styled.div`

`

export const BaseToggle = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease-out;

  span {
    width: ${({ theme }) => theme.rem(16)};
    height: ${({ theme }) => theme.rem(1)};
    display: block;
    border-radius: ${({ theme }) => theme.rem(2)};
    pointer-events: none;

    &:first-child {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      transition: all 0.2s ease-in 0s;

      ${({ $open }) => $open && css`
        transform: translate(-50%, -50%) rotate(0deg);
      `}
    }
  }
`


export const AccordionList = styled.div<TAccordionList>`
  width: 100%;

  ${({ theme, colorScheme }) => css`
    ${BaseHeader} {
      border: 1px solid transparent;
      background-color: ${theme.colorScheme[colorScheme].surface.inside};

      ${({ theme }) => theme.mediaQuery.lg(`

        &[aria-expanded="true"] {
          ${BaseToggle} {
            transform: rotate(180deg);
          }
        }

        &:hover {
          background-color: ${theme.colorScheme[colorScheme].surface.inside};

          ${BaseToggle} {
            transform: rotate(180deg);
          }
        }
      `)}

      &:focus-visible {
        padding-left: ${({ theme }) => theme.rem(16)};
        border: 1px solid ${theme.colorScheme[colorScheme].surface.line};
      }
    }

    ${BaseHeaderContent} {
      color: ${theme.colorScheme[colorScheme].surface.text.base.primary};
    }

    ${BaseToggle} {
      span {
        background-color: ${theme.colorScheme[colorScheme].surface.text.base.primary};
      }
    }

    ${BaseAccordion} {
      border-bottom: 1px solid ${theme.colorScheme[colorScheme].faq.border};
      background-color: ${theme.colorScheme[colorScheme].surface.inside};
    }
  `}
`

export const BaseAccordionEvent = styled(BaseAccordion)`
  border-bottom: 1px solid ${palette.grayscale[900]};

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.rem(24)};
  }
`

export const BaseHeaderEvent = styled(BaseHeader)`
  border: none;
  background-color: transparent;
`

export const BaseHeaderEventContent = styled(BaseHeaderContent)`
  ${Heading} {
    color: ${palette.grayscale[900]};
  }
`

export const BaseContentEvent = styled(BaseContent)`
  padding-top: ${({ theme }) => theme.rem(16)};

  > div {
    padding:0;
  }

  ${Paragraph} {
    color: ${palette.grayscale[900]};
  }
`

export const BaseHeaderPreWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.rem(8)};
  
  > ${Paragraph} {
    color: ${palette.grayscale[900]};
  }
`

export const EventTypeCircle = styled.div`
  width: ${({ theme }) => theme.rem(12)};
  height: ${({ theme }) => theme.rem(12)};
  border-radius: 50%;
  background-color: ${palette.green[200]};

  ${({ theme }) => theme.mediaQuery.xl(`
    width: ${theme.rem(16)};
    height: ${theme.rem(16)};
  `)}
`

export const EventToggle = styled(BaseToggle)`
  border: none;
  
  > i {
    transition: transform 0.2s ease-out;
    transform: scaleY(${({ $open }) => $open ? -1 : 1});
  }
`